import { UserMatterViewHistory } from '@models/userViewHistory';
import { Selector } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { RecentlyViewedSelector } from '@state/recently-viewed/recently-viewed.selector';

export class TopNavBarSelector {
	@Selector([SelectedMatter.id, RecentlyViewedSelector.getTabs])
	static matterPinned(id: string, tabs: UserMatterViewHistory[]): boolean {
		const tab = tabs.find((x) => x.id === id);

		return tab?.pinned;
	}
}
